import { cn } from "@/lib/utils";
import { STATUS_BADGE, RISK_BADGE } from "@/lib/shieldx";

export function StatusBadge({ value, className, testid }) {
  if (!value) return null;
  const key = String(value).toUpperCase();
  return (
    <span
      data-testid={testid}
      className={cn("inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 font-mono text-[11px] font-medium tracking-wide whitespace-nowrap",
        STATUS_BADGE[key] || "bg-slate-800/60 text-slate-300 border border-slate-700/50", className)}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-80" />
      {key.replace(/_/g, " ")}
    </span>
  );
}

export function RiskBadge({ value, className, testid }) {
  if (!value) return null;
  const key = String(value).toUpperCase();
  return (
    <span
      data-testid={testid}
      className={cn("inline-flex items-center rounded-md px-2.5 py-1 font-mono text-[11px] font-semibold tracking-wide",
        RISK_BADGE[key] || "bg-slate-800/60 text-slate-300 border border-slate-700/50", className)}
    >
      {key}
    </span>
  );
}

export function DemoTag({ className }) {
  return (
    <span className={cn("inline-flex items-center gap-1 rounded border border-amber-500/30 bg-amber-500/10 px-1.5 py-0.5 font-mono text-[10px] uppercase tracking-widest text-amber-300/90", className)}>
      Demo / Simulated
    </span>
  );
}
